/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Commission_LabelInputs */

const es_landing_price_commission_label = /** @type {(inputs: Landing_Price_Commission_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comisión por reserva`)
};

const gl_landing_price_commission_label = /** @type {(inputs: Landing_Price_Commission_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comisión por reserva`)
};

const en_landing_price_commission_label = /** @type {(inputs: Landing_Price_Commission_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commission per booking`)
};

/**
* | output |
* | --- |
* | "Commission per booking" |
*
* @param {Landing_Price_Commission_LabelInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_commission_label = /** @type {((inputs?: Landing_Price_Commission_LabelInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Commission_LabelInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_commission_label(inputs)
	if (locale === "en") return en_landing_price_commission_label(inputs)
	return es_landing_price_commission_label(inputs)
});